import $ from 'jquery';
import _ from 'lodash';
import module from 'module';
import {NgTableParams} from 'ng-table/ng-table';
import {MODE} from '../stock-items-inventory-view.component';

import templateUrl from './stock-items-list.template.html';
import './stock-items-list.style.less';

module.component('stockItemsList', {
  templateUrl: templateUrl,
  bindings: {
    customerId: '<',
    showAddItem: '<',
    checkedMode: '=',
    checkedItems: '='
  },
  controller: function ($location, http, branchService, pawnItemTypeCache, systemPropertyCache, commandAccessChecker,
                        pawnItemDefectTypeCache, stockedItemMetalRateCache, pawnItemAttributeTypeCache, pawnMetalTypesCache,
                        command, pawnService, reportService, requestFormatter) {
    const that = this;

    const reportCode = 'StockInventoryItemsReport';

    that.MODE = MODE;

    that.params = $location.search();
    that.metals = [];

    that.pawnItemTypes = [];
    that.pawnItemDefectTypes = [];
    that.metalRates = [];
    that.pawnItemAttributeTypes = [];
    that.branches = [];
    that.qualifiedItemsToHO = [];
    that.checkedForDisplay = [];
    that.checkedForSell = [];
    that.checkedForRepricing = [];
    that.checkedForRecalculation = [];

    that.chkSendToDisplayAll = false;
    that.chkSendToHoDisplayAll = false;
    that.chkAllForSale = false;
    that.enableReturnToHO = false;
    that.chkRepriceAll = false;
    that.chkRecalculateAll = false;

    that.pawnItems = [];

    that.filterConfig = {
      reportCode: reportCode,
      buttons: {
        filter: {
          isVisible: true,
          isDisabled: false,
          action: () => that.filter(),
          text: 'Filter'
        }, download: {
          isVisible: true,
          isDisabled: false,
          action: () => that.downloadXls(),
          text: 'Download xls'
        }, print: {
          isVisible: false,
          isDisabled: false,
          action: null,
          text: 'Print'
        }
      }
    };

    systemPropertyCache.toObservable().first().subscribe(properties => {
      that.headOfficeId = _.find(properties, {code: 'HEAD_OFFICE_BRANCH_ID'}).value;
      const auctionTaggingEnabled = _.find(properties, {code: 'AUCTION_TAGGING_ENABLED'});
      that.auctionTaggingEnabled = auctionTaggingEnabled && auctionTaggingEnabled.value === 'TRUE';
      const recalculateSellingPriceEnabled = _.find(properties, {code: 'RECALCULATE_SELLING_PRICE_ENABLED'});
      that.recalculateSellingPriceEnabled = Boolean(recalculateSellingPriceEnabled && recalculateSellingPriceEnabled.value === 'TRUE');
    });

    branchService.toObservable().first().subscribe(branches => {
      that.branches = branches;
    });

    // Read pawn meta types
    pawnMetalTypesCache.toObservable().subscribe(types => that.metals = types);

    // Read pawn item types
    pawnItemTypeCache.toObservable().subscribe(itemTypes => {
      that.pawnItemTypes = itemTypes;
    });

    // Read pawn item defect types
    pawnItemDefectTypeCache.toObservable().subscribe(defectTypes => {
      that.pawnItemDefectTypes = defectTypes;
    });

    // Read pawn metal rates
    stockedItemMetalRateCache.toObservable().subscribe(rates => {
      that.metalRates = rates;
    });

    // Read pawn item attributes types
    pawnItemAttributeTypeCache.toObservable().subscribe(attributeTypes => {
      that.pawnItemAttributeTypes = attributeTypes;
    });

    commandAccessChecker.canExecuteCommandObservable()
      .subscribe(canExecuteCommand => {
        this.isReprice = canExecuteCommand('RepriceStockedItems');
        this.canRecalculateSellingPrice = canExecuteCommand(MODE.RECALCULATE_SELLING_PRICE.command);
        this.canSendForDisplay = canExecuteCommand(MODE.SEND_FOR_DISPLAY.command);
        this.canSendToHeadOffice = canExecuteCommand(MODE.SEND_TO_HO.command);
      });

    // The item actions row carries the recalculation button, so it has to appear for a
    // user who has only that command - but never because of a command whose feature is
    // switched off.
    that.showItemActions = () => Boolean(
      that.canSendForDisplay
      || that.canSendToHeadOffice
      || (that.recalculateSellingPriceEnabled && that.canRecalculateSellingPrice)
    );

    // The Actions row opens with the "Actions:" label cell and then one spacer cell that
    // has to cover every remaining leading data column, so each action button lands under
    // its own header. Auction tagging adds two of those columns (Origin Branch and Cost),
    // so the spacer is 14 wide with it on and 12 without - the label cell makes up the
    // 15th / 13th. Bound with ng-attr-colspan, because interpolating colspan directly is
    // not reliable in AngularJS.
    that.actionsSpacerColspan = () => that.auctionTaggingEnabled ? 14 : 12;

    that.getTypeLabel = (typeId) => {
      let type = _.find(that.pawnItemTypes, {id: typeId});
      return type && type.name ? type.name : '-';
    };

    that.filter = () => {
      // on filter change
      that.pawnItems = [] // hide previously paginated results
      that.tableConfig.page(1); // set up first page as default
      that.tableConfig.reload(); // get new results
    };

    that.downloadXls = () => reportService.downloadXls({
      reportCode,
      params: {
        ...that.params,
        customerId: that.customerId // hidden parameter
      },
      reportName: 'Pawned_Stock_Items_Report.xlsx'
    });

    that.safeParse = (value) => {
      if (typeof value !== 'string') return value;
      try {
        return JSON.parse(value);
      } catch(error) {
        return value; // fallback to original string
      }
    }

    // Call service for default filter config
    that.tableConfig = new NgTableParams({
      count: 50,
    }, {
      counts: [],
      paginationMaxBlocks: 8,
      paginationMinBlocks: 3,
      getData: params => {
        const itemCategoryExtended = (() => {
          try {
            return that.params && that.params.itemCategoryExtendedCode
              ? JSON.parse(that.params.itemCategoryExtendedCode)
              : {};
          } catch(error) {
            return {};
          }
        })();
        const dateRangeFrom = that.params && that.params.date_range && that.params.date_range.from
          ? that.safeParse(that.params.date_range.from) : null;
        const dateRangeTo = that.params && that.params.date_range && that.params.date_range.to
          ? that.safeParse(that.params.date_range.to) : null;
        const queryParams = {
          pageNo: params.page() - 1,
          pageSize: params.count(),
          customerId: that.customerId,
          categoryId: (itemCategoryExtended || {}).categoryId || null,
          isPlain: (itemCategoryExtended || {}).isPlain,
          typeIds: (that.params['itemTypeExtendedCode[]'] || []).join(','),
          tagIds: that.params['pawnTagId[]'],
          status: that.auctionTaggingEnabled ? that.params['pawnItemStatus[]'] : that.params.pawnStatus || null,
          branchIds: that.params.branchId || null,
          originBranchIds: that.params['originBranchId[]'],
          auctionId: that.params.pawnAuctionId || null,
          trackingCode: that.params.trackingCode || null,
          itemNumber: that.params.pawnItemNumber || null,
          ticketNumber: that.params.pawnTicketNumber || null,
          officialReceiptNumber: that.params.officialReceiptNumber,
          dateFrom: dateRangeFrom,
          dateTo: dateRangeTo
        };

        requestFormatter.nullifyParams(queryParams);

        that.enableReturnToHO = !that.customerId && (that.params.branchId === null || Number(that.headOfficeId) !== that.params.branchId);

        return http.post(`/products/pawns/stock-items?${$.param(queryParams, true)}`, {nxLoaderText: 'Loading stock items'})
          .success(async (items) => {
            that.chkSendToDisplayAll = false;
            that.chkSendToHoDisplayAll = false;
            that.chkAllForSale = false;
            that.chkRepriceAll = false;
            that.chkRecalculateAll = false;
            that.tableConfig.total(items.totalCount);

            const selectedToSendPawnItemIdSet = new Set(that.checkedForDisplay.map(i => i.id));
            const selectedToHOPawnItemIdSet = new Set(that.qualifiedItemsToHO.map(i => i.id));
            const selectedToSellPawnItemIdSet = new Set(that.checkedForSell.map(i => i.id));
            const selectedForRepricingPawnItemIdSet = new Set(that.checkedForRepricing.map(i => i.id));
            const selectedForRecalculationPawnItemIdSet = new Set(that.checkedForRecalculation.map(i => i.id));

            const preparedItems = await Promise.all(
              items.result.map(
                async pawnItem => {
                  const originBranch = _.find(that.branches, {id: pawnItem.originBranchId});
                  return {
                    ...pawnItem,
                    toSend: selectedToSendPawnItemIdSet.has(pawnItem.id),
                    toHO: selectedToHOPawnItemIdSet.has(pawnItem.id),
                    toSell: selectedToSellPawnItemIdSet.has(pawnItem.id),
                    forRepricing: selectedForRepricingPawnItemIdSet.has(pawnItem.id),
                    forRecalculation: selectedForRecalculationPawnItemIdSet.has(pawnItem.id),
                    branchName: _.find(that.branches, {id: pawnItem.branchId}).name,
                    originBranchName: originBranch ? originBranch.name : '-',
                    categoryLabel: that.getTypeLabel(pawnItem.categoryId),
                    typeLabel: that.getTypeLabel(pawnItem.typeId),
                    subtypeLabel: that.getTypeLabel(pawnItem.subtypeId),
                    details: that.readItemDetails(pawnItem),
                  };
                }
              )
            );

            that.tableConfig.data = that.pawnItems = preparedItems;
          });
      }
    });

    that.tableConfig.page(1);

    if (Object.keys(that.params).length !== 0) {
      that.filter();
    }

    that.itemClicked = (item, $event) => {
      $event.stopPropagation();
      // let either input or item selection action at once
      if ($event.target.nodeName === 'INPUT') {
        return;
      }
      that.selectedItemId = item.id;
    };

    that.hideInlinePanel = () => {
      that.selectedItemId = null;
    };

    that.readItemDetails = (item) => {
      return pawnService.buildDescription(item, that.pawnItemDefectTypes, that.pawnItemTypes, that.metals, that.pawnItemAttributeTypes, that.metalRates);
    };

    that.checkItem = (mode, item) => {
      let isChecked = false;
      let items = [];

      switch (mode.name) {
        case that.MODE.SEND_FOR_DISPLAY.name: {
          isChecked = item.toSend
          items = that.checkedForDisplay;
          break;
        }
        case that.MODE.SEND_TO_HO.name: {
          isChecked = item.toHO;
          items = that.qualifiedItemsToHO;
          break;
        }
        case that.MODE.SELL.name: {
          isChecked = item.toSell
          items = that.checkedForSell;
          break;
        }
        case that.MODE.REPRICE_STOCKED_ITEMS.name: {
          isChecked = item.forRepricing
          items = that.checkedForRepricing;
          break;
        }
        case that.MODE.RECALCULATE_SELLING_PRICE.name: {
          isChecked = item.forRecalculation;
          items = that.checkedForRecalculation;
          break;
        }
      }
      const find = items.map(i => i.id).indexOf(item.id);
      if (isChecked && find === -1) {
        items.push(item);
      } else {
        if (find > -1) {
          items.splice(find, 1);
        }
      }
      return items;
    };

    that.selectAllForSale = () => {
      _.forEach(that.tableConfig.data, line => {
        const find = that.checkedForSell.map(i => i.id).indexOf(line.id);
        if (that.chkAllForSale) {
          if (line.status === 'READY_FOR_SALE' && find === -1) {
            that.checkedForSell.push(line);
            line.toSell = true;
          }
        } else {
          line.toSell = false;
          if (find > -1) {
            that.checkedForSell.splice(find, 1);
          }
        }
      });
    };

    that.sendToDisplayAll = () => {
      _.forEach(that.tableConfig.data, line => {
        const find = that.checkedForDisplay.map(i => i.id).indexOf(line.id);
        if (that.chkSendToDisplayAll) {
          if (that.isSendToDisplayCheckboxEnabled(line) && find === -1) {
            that.checkedForDisplay.push(line);
            line.toSend = true;
          }
        } else {
          line.toSend = false;
          if (find > -1) {
            that.checkedForDisplay.splice(find, 1);
          }
        }
      });
    };

    that.sendToHoDisplayAll = () => {
      _.forEach(that.tableConfig.data, line => {
        const find = that.qualifiedItemsToHO.map(i => i.id).indexOf(line.id);
        if (that.chkSendToHoDisplayAll) {
          if (line.status === 'READY_FOR_SALE' && find === -1) {
            that.qualifiedItemsToHO.push(line);
            line.toHO = true;
          }
        } else {
          line.toHO = false;
          if (find > -1) {
            that.qualifiedItemsToHO.splice(find, 1);
          }
        }
      });
    };

    that.showSendReport = (mode, items) => {
      that.checkedMode = mode;
      that.checkedItems = items;
    };

    that.addItem = () => {
      $location.path('/dashboard/stocked-items/item/create');
    };

    that.batchUpload = () => {
      $location.path('/dashboard/stocked-items/batch-upload');
    }

    that.retag = () => {
      $location.path('/dashboard/stocked-items/retag');
    }

    that.isSendToDisplayCheckboxEnabled = (line) => {
      return ['NEW', 'UNSOLD', 'PENDING'].includes(line.status)
    }

    that.isSellCheckboxEnabled = (line) => {
      return ['READY_FOR_SALE'].includes(line.status)
    }

    /**
     * Repricing methods below
     */
    that.isEligibleForRepricing = (item) => {
      return ['NEW', 'UNSOLD', 'READY_FOR_SALE'].includes(item.status) && item.categoryLabel == 'Jewelry';
    }

    that.showRepriceReport = (mode, items) => {
      that.checkedMode = mode;
      that.checkedItems = items;
    };

    that.repriceAll = () => {
      _.forEach(that.tableConfig.data, line => {
        const index = that.checkedForRepricing.map(i => i.id).indexOf(line.id);
        if (that.chkRepriceAll) {
          if (that.isEligibleForRepricing(line) && index === -1) {
            that.checkedForRepricing.push(line);
            line.forRepricing = true;
          }
        } else {
          line.forRepricing = false;
          if (index > -1) {
            that.checkedForRepricing.splice(index, 1);
          }
        }
      });
    }

    /**
     * Selling price recalculation methods below
     */

    // Recalculation accepts PENDING on top of the repricing statuses: a pending
    // item is still active stock (it lands there when pulled off display or when
    // an inter-branch transfer is confirmed) and has to carry a current selling
    // price before it can be sold. Repricing keeps its own narrower set, so this
    // deliberately does NOT alias isEligibleForRepricing.
    that.isEligibleForRecalculation = (item) => {
      return ['NEW', 'UNSOLD', 'READY_FOR_SALE', 'PENDING'].includes(item.status) && item.categoryLabel == 'Jewelry';
    }

    that.showRecalculateSummary = (mode, items) => {
      that.checkedMode = mode;
      that.checkedItems = items;
    };

    that.recalculateAll = () => {
      _.forEach(that.tableConfig.data, line => {
        const index = that.checkedForRecalculation.map(i => i.id).indexOf(line.id);
        if (that.chkRecalculateAll) {
          if (that.isEligibleForRecalculation(line) && index === -1) {
            that.checkedForRecalculation.push(line);
            line.forRecalculation = true;
          }
        } else {
          line.forRecalculation = false;
          if (index > -1) {
            that.checkedForRecalculation.splice(index, 1);
          }
        }
      });
    }

    that.$onDestroy = () => {
      // Skip clearing when the next route is /dashboard/stocked-items itself —
      // callers like item-actions.goToStockItemPage() set $location.search()
      // just before triggering the route change, and the incoming stock-items-list
      // needs to read those params
      if ($location.path() !== '/dashboard/stocked-items') {
        $location.search({});
      }
    }
  }
});
